/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer: string; };
type HookTuple = [
  response: vp.TransactionsCancelResponse,
  TransactionCancel: (params: vp.TransactionsCancelRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostTransactionCancel: ApiHook = ({ api, bearer }) => {
  const [shouldTransactionCancel, setShouldTransactionCancel] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [params, setParams] = useState<vp.TransactionsCancelRequest>({
    TransactionID: '',
    Amount: '',
  });
  const [response, setResponse] = useState<vp.TransactionsCancelResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
    TransactionStatus: '',
    Timestamp: '',
  });

  useEffect(() => {
    if (!shouldTransactionCancel) return () => {};

    const TransactionCancel = async () => {
      setDataFetchingInfo(true, 'setting as default..', 'fullScreen');
      const res = await api.postTransactionCancel(params, bearer, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldTransactionCancel) void TransactionCancel();
    setShouldTransactionCancel(false);
    return () => {
      source.cancel();
    };
  }, [shouldTransactionCancel]);

  return [
    response,
    (_params: vp.TransactionsCancelRequest) => {
      setParams(_params);
      setShouldTransactionCancel(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
        TransactionStatus: '',
        Timestamp: '',
      });
      setShouldTransactionCancel(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostTransactionCancel);
